import { render, staticRenderFns } from "./PrecalificacionBancaria.vue?vue&type=template&id=2c428888&scoped=true&"
import script from "./PrecalificacionBancaria.vue?vue&type=script&lang=js&"
export * from "./PrecalificacionBancaria.vue?vue&type=script&lang=js&"
import style0 from "./PrecalificacionBancaria.vue?vue&type=style&index=0&id=2c428888&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c428888",
  null
  
)

export default component.exports